module.exports = __webpack_public_path__ + "assets/images/pages/workshops/workshops-header.png?0fbacf21";